import { render, staticRenderFns } from "./agency-fee.vue?vue&type=template&id=58769724&scoped=true"
import script from "./agency-fee.vue?vue&type=script&lang=js"
export * from "./agency-fee.vue?vue&type=script&lang=js"
import style0 from "./agency-fee.vue?vue&type=style&index=0&id=58769724&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58769724",
  null
  
)

export default component.exports